import Vue from 'vue'
import Router from 'vue-router'
import userRoutes from './user';
import gettingRestClientObject from '../../services/utils/cms-helper'
var gettingRestClient = gettingRestClientObject();
import Snotify, { SnotifyPosition } from 'vue-snotify'
const options = {
	toast: {
		position: SnotifyPosition.rightTop
	}
}
Vue.use(Snotify, options)
const NotFound = () => import('Views/NotFound.vue');

Vue.use(Router)

const router = new Router({
	mode: 'history',
	routes: [
		userRoutes,
		// adminRoutes,
		{
			path: '*',
			component: NotFound,
			name: 'NotFound'
		},
	]
})

router.beforeEach((to, from, next) => {
	var user = localStorage.getItem("embryo");
	if (user != null && user != undefined) {
		var userData = JSON.parse(user);
		var useDetails = userData.user_data;
		if ((!useDetails.isPhoneNumberVerified) && to.path !== '/account/profile') {
			Vue.prototype.$snotify.warning(gettingRestClient.getValidationMsgByCode("M039"), {
				closeOnClick: false,
				pauseOnHover: false,
				timeout: 1000,
				showProgressBar: false,
			});
			next({ path: '/account/profile' })
		}
		else if (to.path === '/products' && (to.query.category == null || to.query.subcategory == null)) {
			var cat = to.query.category ? to.query.category : "" || "";
			var subcat = to.query.subcategory ? to.query.subcategory : "" || ""
			next({ path: '/products', query: { category: cat, subcategory: subcat } })
		}
		else {
			next()
		}
	}
	else if (to.path === '/products' && (to.query.category == null || to.query.subcategory == null)) {
		var cat2 = to.query.category ? to.query.category : "" || "";
		var subcat2 = to.query.subcategory ? to.query.subcategory : "" || ""
		next({ path: '/products', query: { category: cat2, subcategory: subcat2 } })
	}
	else {
		next()
	}
})

export default router





















// export default new Router({
// 	mode: 'history',
// 	routes: [
// 		userRoutes,
// 		// adminRoutes,
// 		{ 
// 			path: '*',
// 			component: NotFound, 
// 			name:'NotFound'
// 		},
// 	]
// })




// router.beforeEach((to, from, next) => {
// 	var user = localStorage.getItem("embryo");
// 	if (user != null && user != undefined) {
// 		var userData = JSON.parse(user);
// 		var useDetails = userData.user_data;
// 		if ((!useDetails.isPhoneNumberVerified) && to.path !== '/account/profile') {
// 			next({ path: '/account/profile' })
// 		}
// 	}
// })

